import { getOtherLocale } from 'src/i18n/getOtherLocale'
import { normalizeLocale } from 'src/i18n/config'

const LOCALE_ORDER = ['pl', 'en']
const INVALID_PATH_SEGMENT_REGEX = /(^|\/)(undefined|null)(?=\/|$|\?)/
const UNRESOLVED_PARAM_REGEX = /\/:[^/]+/

const sortLocales = (left, right) => {
  const leftOrder = LOCALE_ORDER.indexOf(left)
  const rightOrder = LOCALE_ORDER.indexOf(right)

  if (leftOrder !== -1 || rightOrder !== -1) {
    if (leftOrder === -1) return 1
    if (rightOrder === -1) return -1
    return leftOrder - rightOrder
  }

  return left.localeCompare(right)
}

const isValidLangChangerPath = (path) => {
  if (typeof path !== 'string' || !path) {
    return false
  }

  if (INVALID_PATH_SEGMENT_REGEX.test(path)) {
    return false
  }

  if (UNRESOLVED_PARAM_REGEX.test(path)) {
    return false
  }

  return true
}

export const getLangChangerOptions = (langChangerState, currentLocale) => {
  if (!langChangerState) {
    return []
  }
  const rawOptions = langChangerState.options

  if (rawOptions) {
    try {
      const parsed = JSON.parse(rawOptions)

      return Object.entries(parsed)
        .map(([locale, path]) => ({ locale: normalizeLocale(locale), path }))
        .filter(({ locale, path }) => locale && locale !== currentLocale && isValidLangChangerPath(path))
        .sort((a, b) => sortLocales(a.locale, b.locale))
    } catch (error) {
      console.warn('Failed to parse language changer options', error)
    }
  }

  // Legacy pages still expose only a single alternate path, so the fallback stays pl/en-only.
  const fallbackLocale = getOtherLocale(currentLocale)
  const fallbackPath = isValidLangChangerPath(langChangerState.path) ? langChangerState.path : null

  return fallbackLocale && fallbackPath ? [{ locale: fallbackLocale, path: fallbackPath }] : []
}
